<template>
  <transition
    name="demo-processing"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div
      v-if="show"
      class="demo-submission-processing modal-full bc-black-op z-100"
      role="status"
      aria-live="polite"
      aria-label="Processing demo submission"
    >
      <div class="demo-submission-processing__backdrop" />
      <div class="demo-submission-processing__card bc-brand p-lg d-f fd-c ai-c tt-up w-60 g">
        <h4 class="m-0">Processing, please wait...</h4>
        <div class="demo-submission-processing__bar-track">
          <div class="demo-submission-processing__bar" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "DemoSubmissionProcessing",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    beforeEnter(el) {
      const backdrop = el.querySelector(".demo-submission-processing__backdrop");
      if (backdrop) {
        backdrop.style.opacity = "0";
        backdrop.style.transition = "opacity 0.3s ease";
      }
    },
    enter(el, done) {
      const card = el.querySelector(".demo-submission-processing__card");
      const backdrop = el.querySelector(".demo-submission-processing__backdrop");
      if (backdrop) backdrop.style.opacity = "1";
      const finish = () => {
        if (card) {
          card.removeEventListener("animationend", onEnd);
          card.classList.remove("demo-processing-card--enter");
        }
        clearTimeout(fallback);
        done();
      };
      const onEnd = (e) => {
        if (e.target === card && e.animationName === "demo-processing-card-in")
          finish();
      };
      const fallback = setTimeout(finish, 400);
      requestAnimationFrame(() => {
        if (card) {
          card.classList.add("demo-processing-card--enter");
          card.addEventListener("animationend", onEnd);
        } else {
          finish();
        }
      });
    },
    afterEnter(el) {
      const backdrop = el.querySelector(".demo-submission-processing__backdrop");
      if (backdrop) backdrop.style.opacity = "";
    },
    beforeLeave(el) {
      const card = el.querySelector(".demo-submission-processing__card");
      const backdrop = el.querySelector(".demo-submission-processing__backdrop");
      if (backdrop) {
        backdrop.style.transition = "opacity 0.3s ease";
      }
      if (card) {
        card.style.transition =
          "transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease";
      }
    },
    leave(el, done) {
      const card = el.querySelector(".demo-submission-processing__card");
      const backdrop = el.querySelector(".demo-submission-processing__backdrop");
      el.offsetHeight;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (backdrop) backdrop.style.opacity = "0";
          if (card) {
            card.style.opacity = "0";
            card.style.transform = "translateY(24px)";
            const finish = () => {
              card.removeEventListener("transitionend", onEnd);
              clearTimeout(fallback);
              done();
            };
            const onEnd = (e) => {
              if (e.target === card && e.propertyName === "transform") finish();
            };
            card.addEventListener("transitionend", onEnd);
            const fallback = setTimeout(finish, 400);
          } else {
            done();
          }
        });
      });
    },
    afterLeave() {
      // no-op; element is removed
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";

@keyframes demo-processing-card-in {
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.demo-submission-processing {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.demo-submission-processing__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-submission-processing__card {
  position: relative;
  z-index: 1;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;

  &.demo-processing-card--enter {
    animation: demo-processing-card-in 0.35s
      cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  }
}

.demo-submission-processing__bar-track {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  overflow: hidden;
}

.demo-submission-processing__bar {
  height: 100%;
  width: 30%;
  background: currentColor;
  border-radius: 2px;
  animation: demo-processing-bar 1.2s ease-in-out infinite;
}

@keyframes demo-processing-bar {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(233%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
